export const BFF_BASE_URL = process.env.REACT_APP_BFF_BASE_URL;
